import { observer } from "mobx-react-lite";
import type React from "react";
import type { FC } from "react";

const Filter: FC<React.PropsWithChildren<unknown>> = ({ children }) => (
  <section className="DataTable__item px-6">{children}</section>
);

export default observer(Filter);
